import { stateOptions } from '../commonStateTaxData';

export const basicInfo = [
  {
    id: 'employee_first_name',
    title: 'First name',
    is_required: true,
    question_type: 'short_text',
  },
  {
    id: 'employee_middle_name',
    title: 'Middle initial',
    question_type: 'short_text',
    rules: [
      {
        category: 'regex',
        action: 'match',
        value: '^[a-zA-Z]{1}$',
        customErrorMessage: 'The middle initial can only contain 1 letter.',
      },
    ],
  },
  {
    id: 'employee_last_name',
    title: 'Last name',
    is_required: true,
    question_type: 'short_text',
  },
  {
    id: 'employee_ssn',
    title: 'Social Security number',
    is_required: true,
    placeholder: '9 digits',
    question_type: 'identity',
    identity_type: 'ssn',
    rules: [
      {
        category: 'regex',
        action: 'match',
        value: '^\\d{9}$',
      },
    ],
  },
  {
    id: 'street_address',
    title: 'Home address',
    is_required: true,
    question_type: 'short_text',
  },
  {
    id: 'city_or_town',
    title: 'City or town',
    is_required: true,
    question_type: 'short_text',
  },
  {
    id: 'state',
    title: 'State',
    is_required: true,
    question_type: 'dropdown',
    options: stateOptions,
  },
  {
    id: 'zip_code',
    title: 'Zip code',
    is_required: true,
    question_type: 'short_text',
    placeholder: '5 digits',
    rules: [
      {
        category: 'regex',
        action: 'match',
        value: '\\d{5}',
      },
    ],
  },
];

const getExemptionTitle = (rate, allowance) => `All Kentucky wage earners are taxed at a flat ${rate}% rate with a standard deduction allowance of $${allowance}. The Department of Revenue annually adjust the standard deduction in accordance with KRS 141.081(2)(a). If you are exempt, please choose one of the following: `;

export const getExemptionQuestions = (version) => {
  const baseQuestion = {
    id: 'exemption_from_withholding',
    question_type: 'long_multiple_choice',
    is_required: true,
    options: [
      {
        codeValue: 'no_ky_income_tax_liability',
        shortName: 'Kentucky income tax liability is not expected this year.',
      },
      {
        codeValue: 'non_resident_military_spouse',
        shortName: 'You qualify for the nonresident military spouse exemption.',
      },
      {
        codeValue: 'work_in_ky',
        shortName: 'You work in Kentucky and reside in a reciprocal state.',
      },
      {
        codeValue: 'fort_campbell_exemption',
        shortName: 'You qualify for the Fort Campbell Exemption Certificate.',
      },
    ],
  };

  const versions = {
    '11_22': { rate: 4.5, allowance: '2,980' },
    '11_23': { rate: 4, allowance: '3,160' },
    '11_24': { rate: 4, allowance: '3,270' },
  };

  const { rate, allowance } = versions[version] || versions['11_24'];

  return [
    {
      ...baseQuestion,
      title: getExemptionTitle(rate, allowance),
    },
  ];
};

export const stateOfResidenceQuestion = [
  {
    id: 'state_of_residence',
    title: 'Select your state of residence',
    question_type: 'dropdown',
    is_required: true,
    options: stateOptions,
  },
];

export const additionalWithholdingQuestion = [
  {
    id: 'additional_withholding',
    title: 'Additional withholding per pay period under agreement with employer',
    question_type: 'short_text',
    rules: [
      {
        category: 'regex',
        action: 'match',
        value: '^[0-9]+(.[0-9]{1,2})?$',
      },
    ],
  },
];
